import React from "react";
import PropTypes from "prop-types";
import css from "./VirtualCheckInSchedule.scss";
import VirtualCheckInDayRow from "./VirtualCheckInDayRow";
import Icon from "SF/MaterialIcon";
import {SFVirtualCheckInDaySchedule, SFVirtualCheckInModifySchedule} from "utils/types";
import {daysOfTheWeekOptions} from "utils/time";
import ScheduleDisplayPreview from "./ScheduleDisplayPreview";

// Returns the days that are available to be selected in the row.
function isDayAvailableToSelect(checkInSchedule, dayOfWeekIdx) {
    return (dayOfWeek) => !checkInSchedule.find((checkInScheduleRow, checkInScheduleRowIndex) =>
        (checkInScheduleRowIndex !== dayOfWeekIdx && checkInScheduleRow.dayOfWeek === dayOfWeek.value ));
}
// Returns days that have not already been used by other rows within the schedule.
function availableDaysOfWeek(checkInSchedule, dayOfWeekIdx) {
    return daysOfTheWeekOptions.filter(isDayAvailableToSelect(checkInSchedule, dayOfWeekIdx));
}

const VirtualCheckInSchedule = (props) => {
    const renderDays = () =>
        props.checkInSchedule !== null && props.checkInSchedule.map((daySchedule, idx) =>
               <VirtualCheckInDayRow daySchedule={daySchedule}
                                     availableDaysOfWeek={availableDaysOfWeek(props.checkInSchedule, idx)}
                                     key={idx}
                                     rowIdx={idx}
                                     abbreviatedTZ={props.abbreviatedTZ}
                                     modifyCheckInSchedule={props.modifyCheckInSchedule} />
    );

    return (
        <>
            <div className={css['virtual-schedule']}>
                {renderDays()}
            </div>
            <div className={css['button-group']}>
                <button className={css['add-days-and-times']} onClick={() => props.modifyCheckInSchedule.addDayRow()}>
                    <Icon icon="add" aria-hidden={true} />Add Days & times
                </button>
                <button className={css['remove-all-days']} onClick={() => props.modifyCheckInSchedule.removeAllRows()} >
                    <Icon icon="settings_backup_restore" aria-hidden={true} />Remove All Open Hours
                </button>
            </div>
            <ScheduleDisplayPreview schedule={props.checkInSchedule}/>
        </>
    );
}

VirtualCheckInSchedule.propTypes = {
    checkInSchedule: PropTypes.arrayOf(SFVirtualCheckInDaySchedule).isRequired,
    abbreviatedTZ: PropTypes.string.isRequired,
    modifyCheckInSchedule: SFVirtualCheckInModifySchedule
}

export default VirtualCheckInSchedule;

